import { useContext } from 'react';

import { PaypalContext } from './context';
import type { PaypalState } from './context';

export function usePaypal(): PaypalState {
	return useContext(PaypalContext);
}
